import { useState } from "react";
import { Loader2, Plus } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from "./ui/dialog";
import { Field } from "../pages/AuthShell";
import { api, errMsg } from "../lib/api";

export const AddLocationDialog = ({ defaults, onCreated }) => {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: defaults?.name || "", location: "", category: defaults?.category || "" });
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { data } = await api.post("/business/locations", { ...form, location: form.location || null, category: form.category || null });
      toast.success(`${data.label} added — activate it to get its QR code`);
      setOpen(false);
      setForm({ ...form, location: "" });
      onCreated(data);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <button className="btn-secondary whitespace-nowrap" data-testid="add-location-button"><Plus className="w-4 h-4" />Add location</button>
      </DialogTrigger>
      <DialogContent className="rounded-3xl sm:max-w-md" data-testid="add-location-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Add a location</DialogTitle>
          <DialogDescription>Each location gets its own survey link, QR code and dashboard for $29.99/month.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <Field label="Business name" required minLength={2} value={form.name} onChange={set("name")} data-testid="add-location-name-input" />
          <Field label="Location / neighborhood" required value={form.location} onChange={set("location")} data-testid="add-location-location-input" placeholder="e.g. Downtown Bellevue" />
          <Field label="Business type" optional value={form.category} onChange={set("category")} data-testid="add-location-category-input" />
          <button type="submit" disabled={saving} className="btn-primary w-full justify-center !py-3" data-testid="add-location-submit">
            {saving ? <Loader2 className="w-5 h-5 animate-spin" /> : "Add location"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
